<template>
  <transition>
    <modal
      ref="modalCardName"
      no-close-on-backdrop
      white-blur
      id="card-modal-wrapper"
    >
      <template v-slot:content>
        <div class="card-modal" :style="modalStyle">
          <div class="card-modal-content">
            <p tabindex="0" class="text text--virtuallab">
              {{ data.virtualLab }}
            </p>
            <p tabindex="0" class="text text--id">{{ data.idCard }}</p>
            <label tabindex="0" class="text text--label" for="user-name">{{
              data.usernameLabel
            }}</label>
            <input
              :aria-label="data.textInputYourName"
              class="text text--username"
              :style="errorItemName && { border: 'none' }"
              id="user-name"
              ref="usernameInput"
              type="text"
              v-model="username"
              @keypress="isValidLetter($event)"
              @keydown.enter="onNextView"
              maxlength="20"
            />
            <p tabindex="0" class="text text--specialty">
              {{ data.specialty }}
            </p>
            <p tabindex="0" class="text text--specialty-name">
              {{ data.specialtyName }}
            </p>
            <button
              class="card-modal-content__button common-btn"
              :disabled="errorItemName"
              @click="onNextView"
            >
              {{ data.buttonNext }}
            </button>
          </div>
        </div>
      </template>
    </modal>
  </transition>
</template>

<script>
import { ref, computed } from '@vue/composition-api';
import { Helpers } from '@discoveryeducation/core';
import { Modal } from '@discoveryeducation/components';
import useStore from '@/composables/useStore';

export default {
  name: 'ModalCardName',
  components: { Modal },
  setup(props, { root }) {
    const username = ref('');
    const modalCardName = ref(null);
    const usernameInput = ref('');
    const { setUsername } = useStore();

    const showModal = () => modalCardName.value.show();
    const profane = (text) => Helpers.wordsfilter.profane(text);

    const isValidLetter = (e) => {
      const regex = /^[A-Za-zñçÀ-úâ-û ]+$/;
      let char = String.fromCharCode(e.keyCode);
      return regex.test(char) ? true : e.preventDefault();
    };

    const onNextView = () => {
      if (errorItemName.value) return;

      root.getAudioById('button-click').play();
      setUsername(username.value);
      root.onSwapComponent('GamePage');
    };

    const errorItemName = computed(() => {
      return (
        !username.value || profane(username.value) || !username.value.trim()
      );
    });

    const modalStyle = computed(() => {
      return {
        backgroundImage: `url(${root.getImageById('bg-card-name')})`,
      };
    });

    return {
      username,
      modalCardName,
      usernameInput,
      showModal,
      onNextView,
      modalStyle,
      isValidLetter,
      errorItemName,
    };
  },
};
</script>

<style lang="stylus" scoped>

color-black-100 = colors.black-100
color-purple-400 = colors.purple-400
color-green-100 = colors.green-100
color-navy-blue-300 = colors.navy-blue-300

#card-modal-wrapper
  & >>> .modal-wrapper
          align-items flex-start

          .modal-container
            background-color none
            min-width 0
            width auto
            padding 0
            overflow hidden

.card-modal
  height 964px
  width 575px
  background-size 100%
  background-repeat no-repeat
  margin-top -0.9em

  &-content
    position relative
    top 450px
    margin 0 45px
    padding 27px 40px 40px 40px
    color color-black-100

    .text
      width 100%
      font-size 24px
      line-height 32px
      display inline-block
      margin 0

      &--virtuallab
        font-family Nunito-Black
        width 50%
        letter-spacing 0.6px
        color color-green-100

      &--id
        text-transform uppercase
        width 50%
        letter-spacing 0.6px
        text-align right

      &--label
        font-size 40px
        font-family Nunito-Bold
        line-height 54px
        margin-top 13px

      &--username
        background color-purple-400 0% 0% no-repeat padding-box
        height 60px
        border none
        border-bottom 2px solid color-green-100
        padding 11px 18px 8px 18px
        font-family Nunito-SemiBold
        font-size 30px
        letter-spacing 0.75px

      &--specialty
        font-size 18px
        line-height 24px
        letter-spacing 0.45px
        margin-top 20px

      &--specialty-name
        font-family Nunito-Black
        color color-navy-blue-300

    &__button
      margin-top 94px
      float right
</style>
